import { useEffect } from 'react';
import { useGT } from 'gt-react';
import { toast } from '@/components/ui/toast';
import { takeWorkbookHistoryNotice } from './workbookSession';

/**
 * Tells the user, once after a reload, when the edit history couldn't be kept
 * whole: which newest steps came back, or that none could be stored.
 */
export function useWorkbookHistoryNotice(workbookId: string): void {
  const gt = useGT();
  useEffect(() => {
    const notice = takeWorkbookHistoryNotice(workbookId);
    if (!notice) return;
    if (notice.kept === 0)
      toast.info(
        gt("Your edit history couldn't be kept across the reload", {
          context: 'workbook edit history too large to store',
        }),
        {
          description: gt(
            'It was too large for this browser tab to store. Undo starts again from here.',
            { context: 'workbook edit history too large to store detail' },
          ),
        },
      );
    else
      toast.info(
        gt('Kept the last {kept} steps of your edit history', {
          context: 'workbook edit history trimmed to fit storage',
          kept: String(notice.kept),
        }),
        {
          description: gt(
            'The {dropped} oldest steps were too many for this browser tab to store.',
            {
              context: 'workbook edit history trimmed to fit storage detail',
              dropped: String(notice.dropped),
            },
          ),
        },
      );
  }, [workbookId, gt]);
}
